import React from 'react';
import { motion } from 'framer-motion';
import { OCCASIONS } from './data';

const OccasionCard = ({ occasion }) =>
  occasion.image ? (
    <>
      <img src={occasion.image} alt={occasion.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground/85 via-foreground/20 to-transparent" />
      <div className="absolute bottom-0 left-0 p-5">
        <h3 className="font-display text-xl font-bold text-background">{occasion.title}</h3>
        <p className="text-sm text-background/80">{occasion.desc}</p>
      </div>
    </>
  ) : (
    <div className="flex h-full flex-col justify-between rounded-2xl border border-border bg-card p-5 transition-colors group-hover:border-primary/40">
      <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent/25 text-foreground">
        <occasion.icon className="h-5 w-5" />
      </div>
      <div>
        <h3 className="font-display text-lg font-bold tracking-tight">{occasion.title}</h3>
        <p className="text-sm text-muted-foreground">{occasion.desc}</p>
      </div>
    </div>
  );

export const Occasions = () => (
  <section id="occasions" className="bg-muted/40 py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="mx-auto max-w-2xl text-center">
        <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-primary">For every moment</p>
        <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
          One idea, endless occasions
        </h2>
      </div>
      <div className="mt-14 grid auto-rows-[200px] grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {OCCASIONS.map((o, i) => (
          <motion.div
            key={o.title}
            initial={{ opacity: 0, scale: 0.97 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.06 }}
            className={`group relative overflow-hidden rounded-2xl ${o.span}`}
          >
            <OccasionCard occasion={o} />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
